module.exports = __webpack_public_path__ + "img/Clone.1d268bce.svg";